// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dnVeszMnMBvz3uKHSeWA{display:flex;width:100%;align-content:center;justify-content:center}.BgXaw9w0GoTiaj93PRJ_{width:100%;display:flex;justify-content:center;align-content:center;border-bottom:1px solid #ecedf5;margin-bottom:15px}.BgXaw9w0GoTiaj93PRJ_ .NPKjLYnfmYDHyvw3zWhH{padding:18px 10px 22px}.BgXaw9w0GoTiaj93PRJ_ .NPKjLYnfmYDHyvw3zWhH span{color:#8496b9;padding:2px 0;border-bottom:2px solid rgba(0,0,0,0);font-size:0.9166666667rem;font-weight:400;line-height:18px}.BgXaw9w0GoTiaj93PRJ_ .NPKjLYnfmYDHyvw3zWhH span:hover,.BgXaw9w0GoTiaj93PRJ_ .NPKjLYnfmYDHyvw3zWhH span:focus{cursor:pointer;color:#131a4f}.BgXaw9w0GoTiaj93PRJ_ .NPKjLYnfmYDHyvw3zWhH.zVV1jy3GGkPYXkj_LP00 span{color:#141941;border-color:#6e32f0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `dnVeszMnMBvz3uKHSeWA`,
	"navigationList": `BgXaw9w0GoTiaj93PRJ_`,
	"navigationItem": `NPKjLYnfmYDHyvw3zWhH`,
	"active": `zVV1jy3GGkPYXkj_LP00`
};
export default ___CSS_LOADER_EXPORT___;
